<template>
  <footer class="footer">
    <div class="container py-5 main-footer">
      <div class="row gy-5">
        <!-- Company Info Section -->
        <div class="col-lg-4 mb-4 mb-lg-0 pe-lg-5">
          <div class="footer-logo mb-4">
            <img src="../assets/sehrish-logo-white.png" alt="Sehrish mart Logo" width="30" height="30" class="me-2">
            <!-- <span class="logo-text">Sehrish mart</span> -->
          </div>
          <p class="tagline mb-4">
            We are ensuring a delightful shopping experience for every customer.
          </p>
          <div class="social-icons">
            <a href="https://www.facebook.com/sehrishmart55/" target="_blank" class="social-icon"><i class="bi bi-facebook"></i></a>
            <a href="https://www.instagram.com/sehrish_mart.official/" target="_blank" class="social-icon"><i class="bi bi-instagram"></i></a>
            <a href="https://wa.me/8801882124009" target="_blank" class="social-icon"><i class="bi bi-whatsapp"></i></a>
          </div>
          <div class="payment-methods mt-4">
            <span class="payment-label">We accept</span>
            <span class="payment-logos">
              <img src="https://media-prod.sehrish-mart-tech.workers.dev/bkash-Logo-small.png" alt="Bkash" class="payment-icon" />
              <img src="https://media-prod.sehrish-mart-tech.workers.dev/nagad-logo-small.png" alt="Nagad" class="payment-icon" />
            </span>
          </div>
        </div>

        <div class="col-lg-8">
          <div class="row gy-5">
            <!-- Explore Section -->
            <div class="col-6 col-lg-4">
              <h5 class="section-title">Explore</h5>
              <ul class="footer-links">
                <li>
                  <router-link to="/about">
                    About us
                  </router-link>
                </li>
                <li>
                  <router-link to="/search">
                    product list
                  </router-link>
                </li>
                <li>
                  <router-link to="/signup">
                    Sign up
                  </router-link>
                </li>
                <li>
                  <router-link to="/login">
                    Sign in
                  </router-link>
                </li>
              </ul>
            </div>

            <!-- Our Service Section -->
            <div class="col-6 col-lg-4">
              <h5 class="section-title">Our Service</h5>
              <ul class="footer-links">
                <li>
                  <router-link :to="{ path: '/contact' }" >
                      Help Center
                  </router-link>
                </li>
                <li>
                  <router-link v-if="isLoggedIn" to="/orders">
                      Track Order
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ path: '/contact' }">
                      Contact Us
                  </router-link>
                </li>
              </ul>
            </div>

            <!-- Categories Section -->
            <div class="col-6 col-lg-4">
              <h5 class="section-title">Categories</h5>
              <ul class="footer-links">
                <li>
                  <router-link :to="{ path: '/category', query: { c: 'cleansers' } }">
                      Cleansers
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ path: '/category', query: { c: 'face_serums' } }">
                      Face Serums
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ path: '/category', query: { c: 'moisturizer' } }">
                      Moisturizer
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ path: '/category', query: { c: 'sunscreen' } }">
                      Sunscreen
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ path: '/category', query: { c: 'toners' } }">
                      Toners
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Copyright Section -->
    <div class="copyright-bar">
      <div class="container">
        <p class="copyright-text text-center">Sehrish mart © 2026. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: #000000;
  color: #ffffff;
  .main-footer {
    padding: 0 60px;
    .footer-logo {
      display: flex;
      align-items: center;
      img {
        width: 120px;
        height: auto;
      }
      
      .logo {
        height: 40px;
        margin-right: 10px;
      }
      
      .logo-text {
        font-size: 24px;
        font-weight: 600;
        color: #ffffff;
      }
    }
    
    .tagline {
      color: #b3b3b3;
      font-size: 15px;
      line-height: 1.6;
      max-width: 360px;
    }
  
    .social-icons {
      display: flex;
      justify-content: start;
      gap: 12px;
      a {
        margin-left: 0;
      }
      .social-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        border-radius: 12px;
        background-color: #2b2b2b;
        color: #ffffff;
        font-size: 18px;
        transition: background-color 0.2s ease, color 0.2s ease;
  
        &:hover {
          background-color: #ffffff;
          color: #2b2b2b;
        }
      }
    }
  
    .payment-methods {
      display: flex;
      align-items: center;
      gap: 12px;
  
      .payment-label {
        color: #b3b3b3;
        font-size: 14px;
      }
  
      .payment-logos {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 6px 10px;
        background-color: #ffffff;
        border-radius: 8px;
  
        .payment-icon {
          height: 26px;
        }
      }
    }
  
    .section-title {
      color: #ffffff;
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 24px;
    }
  
    .footer-links {
      list-style: none;
      padding: 0;
      margin: 0;
  
      li {
        margin-bottom: 16px;
  
        a {
          color: #b3b3b3;
          text-decoration: none;
          font-size: 15px;
  
          &:hover {
            color: #ff6b6b;
          }
        }
      }
    }
  }
  

  .copyright-bar {
    background-color: #2b2b2b;
    padding: 24px 0;

    .copyright-text {
      color: #b3b3b3;
      font-size: 14px;
      margin: 0;
    }
  }
}
</style>
